const team = [
  {
    name: "Hubert",
    role: "Fondateur",
    description: "Hubert, entrepreneur passionné, a fondé WeMemberz en France avec le rêve de démocratiser l'univers des albums photo et de créer des souvenirs inoubliables.",
    image: "/images/team/hubert.png"
  },
  {
    name: "Shaima", 
    role: "Pôle Communication",
    description: "Créative, Shaima développe notre image de marque en mettant en place des partenariats stratégiques pour accroître notre visibilité, tout en créant du contenu qui valorise pleinement l'album photo.",
    image: "/images/team/charlotte.png"
  },
  {
    name: "Anastasia",
    role: "Pôle Relation Client",
    description: "Attentive et réactive, Anastasia vous garantit une expérience client exceptionnelle à chaque étape de votre projet.",
    image: "/images/team/anastasia.jpg"
  },
  {
    name: "Cédric",
    role: "Pôle Tech",
    description: "C'est l'expert technique de WeMemberz. Cédric veille à ce que nous restions à la pointe de la technologie pour toujours vous offrir des solutions modernes et innovantes.",
    image: "/images/team/cedric.png"
  }
]

export default function TeamSection() {
  return (
    <section className="py-12 lg:py-16 bg-soft-gradient">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center space-y-6 mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-bold text-foreground max-w-4xl mx-auto leading-tight">
            Notre{" "}
            <span className="text-gradient">Équipe</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Une équipe passionnée et experte, dédiée à transformer vos photos en œuvres d'art durables.
          </p>
        </div>

        {/* Team Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {team.map((member, index) => (
            <div 
              key={index}
              className="group text-center space-y-6"
            >
              {/* Photo */}
              <div className="relative mx-auto w-48 h-48 rounded-full overflow-hidden shadow-elegant group-hover:scale-105 transition-smooth">
                <img 
                  src={member.image}
                  alt={`Portrait de ${member.name}, ${member.role} chez Wememberz`}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-hero-gradient opacity-0 group-hover:opacity-20 transition-smooth"></div>
              </div>

              {/* Info */}
              <div className="space-y-3">
                <h3 className="text-xl font-display font-semibold text-foreground">
                  {member.name}
                </h3>
                <p className="text-primary font-medium" style={{ color: 'hsl(var(--stats-orange))' }}>
                  {member.role}
                </p>
                <p className="text-muted-foreground text-sm leading-relaxed">
                  {member.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
